module.exports = "<div id=injected-footer> </div>";


//////////////////
// WEBPACK FOOTER
// ./includes/footer.html
// module id = 9
// module chunks = 0